/* Copyright (c) 2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { ReactNode, useEffect, useRef } from "react";
import { createPortal } from "react-dom";

type Props = {
  children: ReactNode;
};

export function Portal({ children }: Props) {
  const modalRoot = document.querySelector("#root") as HTMLElement;
  const el = useRef(document.createElement("div"));

  useEffect(() => {
    const current = el.current;
    modalRoot?.appendChild(current);
    return () => void modalRoot?.removeChild(current);
  }, [modalRoot]);

  return createPortal(children, el.current);
}
